import React from "react";
import { useLocation } from "react-router-dom";

import Grid from "@Leagues/components/Grid";
import League from "@Leagues/components/League";

const Leagues = (): React.JSX.Element => {
    const location = useLocation();

    const isOnLeagueIndexPage =
        location.pathname === "/leagues/" && location.search === "";

    return isOnLeagueIndexPage ? <Grid /> : <League />;
};

export default Leagues;
